import './text-seo.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { atQuery } from '../../scripts/components/mediaQueries';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTextSeo = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const readMoreBtn = sectionContainer.querySelector('.text-seo__read-more');
  const textDescription = sectionContainer.querySelector('.text-seo__description');

  function seoReadMore() {
    atQuery('max', 'md', () => {

      if (textDescription.scrollHeight > 100) {
        readMoreBtn.style.display = 'block';
      }

      let isExpanded = false;

      readMoreBtn.addEventListener('click', function() {
        if (isExpanded) {
          gsap.to(textDescription, { maxHeight: 100, duration: 1, ease: "power2.inOut" });
          readMoreBtn.innerText = readMoreBtn.getAttribute("data-more");
        } else {
          gsap.to(textDescription, { maxHeight: textDescription.scrollHeight, duration: 1, ease: "power2.inOut" });
          readMoreBtn.innerText = readMoreBtn.getAttribute("data-less");
        }
        isExpanded = !isExpanded;
      });
    });

    atQuery('min', 'md', () => {
      readMoreBtn.style.display = 'none';
    });
  }

  addEventListener("load", (event) => {
    seoReadMore();
  });

  addEventListener("resize", (event) => {
    seoReadMore();
  });

};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.text-seo__section'), (el) => {
    window.dAgency.initTextSeo(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.text-seo__section'), (el) => {
      window.dAgency.initTextSeo(el);
    });
  });
}
